import { render } from "./Status.vue?vue&type=template&id=03c0f71e&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import "./Status.vue?vue&type=style&index=0&id=03c0f71e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aidan\\Documents\\Code\\spotify-vue\\hilow\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c0f71e"]])

export default __exports__